/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Status zadania
 * @export
 * @enum {string}
 */

export const TaskStatusDto = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Done: 'DONE',
    Cancelled: 'CANCELLED'
} as const;

export type TaskStatusDto = typeof TaskStatusDto[keyof typeof TaskStatusDto];



